module.exports = __webpack_public_path__ + "static/media/Bulletblack.d1292de2.svg";